export type TOneKeyRecord<K extends keyof never, V> = { [P in K]: V }

export const oneKeyRecord = <K extends string, V>(
  k: K,
  v: V,
): TOneKeyRecord<K, V> => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return {
    [k]: v,
  } as TOneKeyRecord<K, V>
}
